// src/index.js

import React, { useContext, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/styles/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ThemeContext, ThemeProvider } from './context/ThemeContext';

function Root() {
    const { theme } = useContext(ThemeContext);

    useEffect(() => {
        document.body.className = theme;
    }, [theme]);

    return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider>
        <Root />
    </ThemeProvider>
);
